module.exports = __webpack_public_path__ + "img/barbara_knoefel.8175494a.jpg";